import { NotificationModalProps } from '@masfront/common-b2c'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState: NotificationModalProps = {
  open: false,
  title: '',
  description: '',
  actions: [],
  type: '',
}

export interface SetOpenModalAction {
  isOpen: boolean
}

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    changeModal: (state, action: PayloadAction<NotificationModalProps>) => {
      const { payload } = action

      return {
        ...state,
        ...payload,
      }
    },

    setOpenModal: (state, action: PayloadAction<SetOpenModalAction>) => {
      // eslint-disable-next-line
      state.open = action.payload.isOpen
    },
    resetModal: () => initialState,
  },
})

export const { changeModal, setOpenModal, resetModal } = modalSlice.actions

const modalReducer = modalSlice.reducer
export default modalReducer
